module.exports = {
  "name": "si_LK",
  "day": {
    "abbrev": ["ඉ", "ස", "අ", "බ", "බ්‍ර", "සි", "සෙ"],
    "full": ["ඉරිදා", "සඳුදා", "අඟහරුවාදා", "බදාදා", "බ්‍රහස්පතින්දා", "සිකුරාදා", "සෙනසුරාදා"]
  },
  "month": {
    "abbrev": ["ජන", "පෙබ", "මාර්", "අප්‍රි", "මැයි", "ජූනි", "ජූලි", "අගෝ", "සැප්", "ඔක්", "නෙවැ", "දෙසැ"],
    "full": ["ජනවාරි", "පෙබරවාරි", "මාර්තු", "අප්‍රියෙල්", "මැයි", "ජූනි", "ජූලි", "අගෝස්තු", "සැප්තැම්බර්", "ඔක්තෝබර්", "නොවැම්බර්", "දෙසැම්බර්"]
  },
  "meridiem": ["පෙ.ව.", "ප.ව."],
  "date": "%Y-%m-%d",
  "time24": "%H:%M:%S",
  "dateTime": "%Y-%m-%d %H:%M:%S %z",
  "time12": "%p %I:%M:%S",
  "full": "%Y %B %e වැනි %A %H:%M:%S %z"
};